import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableRulesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableRulesPage;
